module.exports = __webpack_public_path__ + "static/media/preview_mail.70b3301a.svg";